"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMessage = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Protocol.V2.Message';
const createMessage = (channel, data) => {
    const Metadata = effect_1.Schema.Struct({ channel: effect_1.Schema.tag(channel) });
    const LegacyMessage = Metadata.pipe(effect_1.Schema.extend(effect_1.Schema.encodedBoundSchema(data))).annotations({
        identifier: `${exports.NAMESPACE}.LegacyMessage<"${channel}">`,
        description: `An object containing the channel name (\`"${channel}"\`) and ` +
            'the properties for the message being transferred alongside it',
    });
    const Message = Metadata.pipe(effect_1.Schema.extend(effect_1.Schema.Struct({ data }))).annotations({
        identifier: `${exports.NAMESPACE}.Message<"${channel}">`,
        description: `An object containing the channel name (\`"${channel}"\`) and the message data`,
    });
    return effect_1.Schema.transform(LegacyMessage, Message, {
        strict: false, // TypeScript doesn't understand transform of parameterized type.
        decode: ({ channel, ...data }) => ({ channel, data }),
        encode: ({ channel, data }) => ({ channel, ...data }),
    });
};
exports.createMessage = createMessage;
//# sourceMappingURL=message.js.map